<template>
  <div class="w-full">
        
    <div class="p-4 flex justify-between items-center mb-8">
      <p class="text-white">Schedule for {{ dates.topic }}</p>

      

      <button @click="close()" class="bg-white/20 h-8 w-8 rounded-md btn min-h-0 p-0 m-0">
        <Icon class="text-lg text-woodsmoke-50" name="material-symbols:close"></Icon>
      </button>
    </div>

    <div class="w-full">

      <div class="w-full grid grid-cols-7 px-4 text-sm text-white">
        <p class="col-span-4 text-left">Date</p>

        <p class="col-span-2">Amount</p>

        <p>%</p>
      </div>

      <div v-for="_date in computedDates" class="w-full grid grid-cols-7 p-4 border-b border-b-white/10">        

          <div class="w-full col-span-4 text-left">
            {{ formatDate(_date) }}
          </div>
  
          <div class="col-span-2">
            {{ Math.floor(_date.amount * 100) / 100 }}
            {{ _date?.currency }}
          </div>
  
          <div class="">
            {{ Math.floor(_date.percent * 1000) / 1000 }}%
          </div>

      


      </div>


    </div>

    
  </div>
</template>

<script setup>

const props = defineProps(["dates","topic"])
const { dates } = toRefs(props)


import { format } from "date-fns";

const formatDate = ( _claim ) => {
  let _format = "yyyy-MM-dd HH:mm a"
  if(_claim.format){
    _format = _claim.format
  }

  return format(new Date(_claim.timestamp * 1000), _format);
}

const computedDates = computed(() => {
  const _schedule = dates.value?.dates?.sort((a, b) => a.timestamp - b.timestamp)
  console.log("_schedule", _schedule);

  let formattedSchedule = []

  for(let _s of _schedule) {

    if(_s?.type === 'tge') {
      formattedSchedule.push({
        'timestamp': _s?.timestamp,
        'amount': _s?.amount,
        'percent': _s?.percent,
        'format': _s?.format,
      })
    } else if(_s?.type === 'vesting') {

      for(let i=0; i<_s.duration_day; i++) {
        formattedSchedule.push({
          'timestamp': _s?.timestamp + (i*86400),
          'amount': _s?.amount / _s.duration_day,
          'percent': _s?.percent / _s.duration_day,
          'format': _s?.format,
        })
      }

    }

  }

  console.log("formattedSchedule", formattedSchedule);

  return formattedSchedule;
})

const emit = defineEmits(["close"])

const close = () => {
  emit("close")
}


</script>

<style>

</style>